import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { ArrowRight, Play } from 'lucide-react';
import { fetchTestimonialsApi } from '../../services/api';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './AIStudioAndSuccess.css';

const AIStudioAndSuccess = () => {
  const [testimonials, setTestimonials] = useState([]);
  
  let profManSrc = '';
  try { profManSrc = require('../../assets/img/professional-man.png'); } 
  catch(e) { profManSrc = 'https://ui-avatars.com/api/?name=Professional+Man&background=random'; }

  useEffect(() => {
    const loadData = async () => {
      try {
        const tRes = await fetchTestimonialsApi();
        setTestimonials(tRes.data.data || []);
      } catch (err) { console.error('Error fetching testimonials:', err); }
    };
    loadData();
  }, []);

  const getImgUrl = (item) => {
    const url = item.user?.profile_image_url || item.profile_image_url;
    if (url?.startsWith("http")) return url;
    if (url) return `${process.env.REACT_APP_API_URL?.replace("/api", "") || ''}/uploads/${url}`;
    return null; 
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 3 } },
      { breakpoint: 1200, settings: { slidesToShow: 3 } },
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <section className="ai-success-wrapper">
      <div className="ai-success-container">
        
        {/* Left: AI STUDIO */}
        <div className="ai-studio-block">
          <div className="ai-studio-text">
            <h3 className="sub-title text-purple">AI STUDIO</h3>
            <h2 className="section-title-large">Your Personal<br className="d-none d-lg-block"/>Acting Coach</h2>
            <p className="ai-desc">
              Upload a short clip and get<br className="d-none d-lg-block"/>
              AI-powered analysis and actionable<br className="d-none d-lg-block"/>
              suggestions to improve.
            </p>
            <button className="btn-solid prof-btn" style={{marginTop: '20px'}}>
              Analyze My Performance <ArrowRight size={16} style={{marginLeft: '8px'}} />
            </button>
          </div>

          <div className="ai-demo-card">
            <div className="video-player">
              <img 
                src={profManSrc}
                alt="Actor Demo" 
                className="video-thumb" 
              />
              <div className="video-controls">
                <Play className="play-btn" size={20} fill="#fff" strokeWidth={0} />
                <span className="time-badge">-0:32</span>
              </div>
            </div>
            
            <div className="ai-analysis-details">
              <h4 className="analysis-heading">AI Analysis</h4>
              
              <div className="ai-metric-row">
                <span className="metric-name">Emotion</span>
                <div className="bar-wrapper"><div className="bar" style={{width: '88%'}}></div></div>
                <span className="metric-score">88/100</span>
              </div>
              <div className="ai-metric-row">
                <span className="metric-name">Voice Clarity</span>
                <div className="bar-wrapper"><div className="bar" style={{width: '86%'}}></div></div>
                <span className="metric-score">86/100</span>
              </div>
              <div className="ai-metric-row">
                <span className="metric-name">Confidence</span>
                <div className="bar-wrapper"><div className="bar" style={{width: '90%'}}></div></div>
                <span className="metric-score">90/100</span>
              </div>
              <div className="ai-metric-row">
                <span className="metric-name">Expression</span>
                <div className="bar-wrapper"><div className="bar" style={{width: '87%'}}></div></div>
                <span className="metric-score">87/100</span>
              </div>
              <div className="ai-metric-row">
                <span className="metric-name">Pace & Timing</span>
                <div className="bar-wrapper"><div className="bar" style={{width: '85%'}}></div></div>
                <span className="metric-score">85/100</span>
              </div>

              <a href="#" className="view-full-report text-purple" style={{marginTop: '25px', display: 'flex', alignItems: 'center'}}>
                View Full Report <ArrowRight size={14} style={{marginLeft: '4px'}} />
              </a>
            </div>
          </div>
        </div>

        {/* Right: SUCCESS STORIES */}
        <div className="success-stories-block">
          <div className="success-header">
            <h3 className="sub-title text-purple" style={{margin: 0}}>SUCCESS STORIES</h3>
          </div>
          
          <div className="success-slider-container">
            {testimonials.length > 0 ? (
              <Slider {...sliderSettings}>
                {testimonials.map((item) => (
                  <div key={item.id} className="success-slide-wrapper">
                    <div className="success-card">
                      <img 
                        src={getImgUrl(item) || `https://ui-avatars.com/api/?name=${encodeURIComponent(item.name || "User")}&background=f3f2ff&color=4f46e5`} 
                        alt={item.name} 
                        className="success-avatar" 
                      />
                      <p className="success-quote">
                        "{item.description?.length > 120 ? `${item.description.substring(0, 120)}...` : item.description || "The process is simple and transparent."}"
                      </p>
                      
                      <div className="success-divider"></div>
                      
                      <div className="success-author">{item.name}</div>
                      <div className="success-author-role text-purple">{item.talent_name || "Actor"}</div>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div className="text-center py-5">Loading testimonials...</div>
            )}
          </div>
        </div>

      </div>
    </section>
  );
};

export default AIStudioAndSuccess;
